/**
 * useWidgetAccess(key)
 *
 * Permission check specific to widget:<key> grants.
 *
 * Super Admin and AIG staff see every widget regardless of the matrix
 * (skipsPermissionChecks, the API's rule for every grant, so a fresh
 * environment still has someone who can open /settings/widget-permissions).
 * Everyone else, Admin included, gets a strict check against the
 * permissions array. Missing perm → widget hidden. No bootstrap tier
 * fallback — widgets are explicit grants only.
 */

import { useAuth } from '../contexts/AuthContext';
import { useSkipsPermissionChecks } from '../hooks/useSkipsPermissionChecks';
import { widgetPermName } from '@aiga/app-config/permissions';

export function useWidgetAccess(widgetKey: string): boolean {
  const { permissions } = useAuth();
  const skips = useSkipsPermissionChecks();
  if (skips) return true;
  const want = widgetPermName(widgetKey);
  return (permissions ?? []).some((p) => p.name === want);
}
